import { OpenFeature } from '@openfeature/web-sdk';
import type { FeatureFlagKey } from './hooks';

/**
 * Non-hook accessor for boolean feature flags. Use in non-React contexts
 * (Redux thunks, utilities, services). In React components prefer `useFeatureFlag`.
 *
 * Evaluation is synchronous against the cached provider state. Before the provider
 * is initialized (see `ensureFeatureFlagsProvider`) or when flags are disabled
 * (NOOP provider), this returns `defaultValue`.
 */
export function getFeatureFlag(key: FeatureFlagKey, defaultValue = false): boolean {
  return OpenFeature.getClient().getBooleanValue(key, defaultValue);
}
